import React, { Component } from 'react';
import axios from 'axios';
import Modal from './Modal';
import backup from './error.jpg';
import styled from "styled-components";

const StyledResults = styled.section`
  background: #f3f3f3;
  padding-top: 15vh;
  padding-bottom: 15vh;

  ul{
    display:grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    gap: 3rem;
  }

  @media(max-width:504px){
    ul{
      grid-template-columns: repeat(auto-fill, minmax(304px, 1fr));
    }
  }

`

const StyledResult = styled.li`
  background: white;
  display: flex;

  .movieInfo{
    padding: 20px;
    line-height: 1.5;
    display:flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .title{
    font-weight: 500;
  }

  img{
    height: 200px;
    max-width: 150px;
    border-bottom: 4px solid var(--yellow);
  }

  .line{
    width: 70px;
    height: 2px;
    background: var(--yellow);
    margin: 4px 0;
  }

  button{
    width: 100px;
    padding: 3px 2px;
    margin-right: 10px;
    margin-bottom: 3px;
    font-size: 14px;
    border: 0.5px solid var(--black);
    background-color: white;
  }

  button:hover{
    background-color: var(--yellow);
    border: 0.5px solid var(--yellow);
  }

`




class Results extends Component{

  constructor() {
    super();
    this.state = {
      movie:'',
      show: 'hidden'
    }
  }

  loadModal= (e) =>{
    this.apiCall2(e.currentTarget.value)
    this.setState({ show: 'display' })
    
  }


  hideModal = () =>{
    this.setState({show: 'hidden'})
  }

  apiCall2 = (thing) => {
    axios({
      url: `https://www.omdbapi.com/?type=movie&apikey=a1aad806`,
      method: `GET`,
      responseType: `json`,
      params: {
        i: thing,
      }
    }).then((result) => {
      this.setState({
        movie: result.data
      })
    })
  }

  render(){
    if(this.props.movies === undefined){
      return(
        <StyledResults className={"results " + this.props.showResults} ref={this.props.inputRef}>
        <div className="wrapper">
        <h2>Results</h2>
        <p className="tryagain">Did you enter anything? Maybe try a new search.</p>
        </div>
        </StyledResults>

      )
    }else{
      return (
        <StyledResults className={"results " + this.props.showResults} ref={this.props.inputRef}>
      <div className="wrapper">
        <h2>Results</h2>
        <ul>
            {this.props.movies.map( movie =>(
              <StyledResult className="film" key={'s' + movie.imdbID}>
                <img src={movie.Poster !== 'N/A' ? movie.Poster : backup} alt={'movie poster of' + movie.Title} name={movie.imdbID} />
                <div className="movieInfo">
                  <div>
                    <p className="title">{movie.Title}</p>
                    <div className="line"></div>
                    <p>{movie.Year}</p>
                  </div>
                  <div>
                    <button className="learnMore" value={movie.imdbID} onClick={this.loadModal}>Learn More</button>
                    <button aria-label={'nominate' + movie.Title} aria-disabled={this.props.noms.includes(movie.imdbID) ? true : false} value={movie.imdbID} onClick={this.props.addNom}>{this.props.noms.includes(movie.imdbID) ? 'Nominated!' : 'Nominate'}</button>
                  </div>
                </div>
              </StyledResult>
            ))}
        </ul>
        <div>
          <Modal movie={this.state.movie} isModal={this.state.show} goAway={this.hideModal} className="mickey"/>
        </div>
      </div>
      </StyledResults>
      )
    }
  }
}


export default Results;